var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 71,
    viewBox: "0 0 43 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8133 31.1613C42.5115 30.5558 41.8897 30.1738 41.208 30.1738H27.2189L32.2229 2.08239C32.366 1.27573 31.9342 0.475825 31.1775 0.147761C30.4189 -0.177878 29.5346 0.0474697 29.033 0.698131L0.366678 37.9738C-0.0463598 38.5099 -0.116346 39.2324 0.186714 39.8379C0.488525 40.4421 1.11027 40.8247 1.79199 40.8247H15.781L10.7771 68.9162C10.634 69.7228 11.0658 70.5227 11.8225 70.8508C12.0556 70.9511 12.2987 71 12.5411 71C13.0873 71 13.6197 70.7524 13.9671 70.3004L42.6334 33.0248C43.0464 32.488 43.1163 31.7662 42.8133 31.1613Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.5b1e6ab301f792223f4eef4ccd635bf6.svg";
export { ForwardRef as ReactComponent };